export const version = "contracts/5.4.0";
//# sourceMappingURL=_version.js.map